/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Tag_LiveInputs */

const en_for_whom_tag_live = /** @type {(inputs: For_Whom_Tag_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live sessions`)
};

const pl_for_whom_tag_live = /** @type {(inputs: For_Whom_Tag_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trening na żywo`)
};

/**
* | output |
* | --- |
* | "Live sessions" |
*
* @param {For_Whom_Tag_LiveInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_tag_live = /** @type {((inputs?: For_Whom_Tag_LiveInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Tag_LiveInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_tag_live(inputs)
	return en_for_whom_tag_live(inputs)
});